import { render, staticRenderFns } from "./PreviousExamPapersRecords.vue?vue&type=template&id=b406de10&scoped=true"
import script from "./PreviousExamPapersRecords.vue?vue&type=script&lang=js"
export * from "./PreviousExamPapersRecords.vue?vue&type=script&lang=js"
import style0 from "./PreviousExamPapersRecords.vue?vue&type=style&index=0&id=b406de10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b406de10",
  null
  
)

export default component.exports